module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcome_message":"Welcome to ","register_btn_message":"Register this device"},"es":{"welcome_message":"Bienvenido a ","register_btn_message":"Registrar este dispositivo"}}')
  delete Component.options._Ctor
}
